import * as React from 'react';
import * as FieldStyles from './DateField.scss';
import { BaseText } from '../baseText/BaseTextField';

const ONE_HOUR = 3600000; // 3600000 milliseconds is 1 hour
const HEAVY_ASTERISK = '\u2731';

/**
 * @public
 */
export interface IDateFieldProps {
  text?: string | undefined;
  dateValue?: string | number;
  indicatorEnabled?: boolean; // If true, can possibly output a HEAVY_ASTERISK indicator
  isDisabled?: boolean;
  ariaLabel?: string;
}

/**
 * @public
 */
export const DateField: React.StatelessComponent<IDateFieldProps> = (props: IDateFieldProps) => {
  let { text, dateValue, indicatorEnabled, isDisabled, ariaLabel } = props;
  ariaLabel = ariaLabel || text; // Default to text if no ariaLabel given

  let isIndicatorVisible = false;

  let dateTimeValue = (typeof dateValue === 'string') ?
    new Date(dateValue) :
    (typeof dateValue === 'number') ?
      new Date(dateValue) : new Date('');

  // Adds a heavy asterisk if dateValue exist, and it's within last one hour.
  if (!isNaN(dateTimeValue.getTime()) && indicatorEnabled) {
    if (Math.abs(Date.now() - dateTimeValue.getTime()) <= ONE_HOUR) {
      isIndicatorVisible = true;
    }
  }

  if (!text && (!isNaN(dateTimeValue.getTime()))) {
    text = dateTimeValue.toLocaleString();
  }

  if (!text) {
    return null; // save dom elements for empty column
  }

  return (
    <BaseText
      data-automationid='FieldRenderer-date'
      text={ '' }
      ariaLabel={ ariaLabel }
      isDisabled={ isDisabled }
      noTextRender={ true } /* render text as child element */
    >
      { isIndicatorVisible && (
        <span className={ `${FieldStyles.newItem}` }>{ HEAVY_ASTERISK }</span>
      ) }
      { text }
    </BaseText>
  );
};
